mutation CreateBrandMediumUploadSession(
    $brandID: ID!
    $filename: String!
) {
    createBrandMediumUploadSession(
        brandID: $brandID
        filename: $filename
    ) {
        fileURL
        uploadURL
    }
}
